import { createContext, ReactNode, useContext } from 'react';

export type TSendUserToAppContext = { intent: string; name: string; oneLink: string; sendUserToApp: boolean };

export const SendUserToAppContext = createContext<TSendUserToAppContext>({
  intent: '',
  name: '',
  oneLink: '',
  sendUserToApp: false,
});

export const SendUserToAppProvider = ({
  children,
  intent,
  name,
  oneLink,
  sendUserToApp,
}: { children: ReactNode } & TSendUserToAppContext) => {
  return (
    <SendUserToAppContext.Provider value={{ intent, name, oneLink, sendUserToApp }}>
      {children}
    </SendUserToAppContext.Provider>
  );
};

export const useSendUserToApp = () => useContext(SendUserToAppContext);
